// @owners { team: patients }
import { DeliveriesOverview } from '@alto/features';
import React, { useEffect } from 'react';
// eslint-disable-next-line import/no-deprecated
import { fetchDeliveries } from '~shared/actions/deliveries';
// eslint-disable-next-line import/no-deprecated
import { fetchPrescriptions } from '~shared/actions/prescriptions';
// eslint-disable-next-line import/no-deprecated
import { fetchShipments } from '~shared/actions/shipments';
import { getPrescriptions } from '~shared/features/prescriptions/selectors/getPrescriptions';
import getAreShipmentsStale from '~shared/features/shipments/selectors/getAreShipmentsStale';
import {
  getPastShipmentsWithItemsAndAdditionalFields,
  getUpcomingShipmentsWithItemsAndAdditionalFields,
} from '~shared/features/shipments/selectors/getShipmentsWithAdditionalFields';
import { makeCachedSortByISODateString } from '~shared/helpers/sort';
import { useDispatchShared, useSelectorShared } from '~shared/store';
import { useRemoveNotifications } from '~web/hooks';

export const DeliveriesList = () => {
  useRemoveNotifications();
  const dispatch = useDispatchShared();
  const prescriptions = useSelectorShared(getPrescriptions);
  const hasStaleShipments = useSelectorShared(getAreShipmentsStale);
  const loading = useSelectorShared(
    (state) =>
      state.ui.loading.fetchDeliveriesLoading ||
      state.ui.loading.fetchPrescriptionsLoading ||
      state.ui.loading.fetchShipmentsLoading,
  );

  const sortByDate = makeCachedSortByISODateString();
  // Ascending sort - smallest dates (soonest upcoming) first
  const upcomingShipments = useSelectorShared(getUpcomingShipmentsWithItemsAndAdditionalFields).sort((a, b) =>
    sortByDate(a.date, b.date),
  );
  // Descending sort - largest dates (most recent) first
  const pastShipments = useSelectorShared(getPastShipmentsWithItemsAndAdditionalFields).sort((a, b) =>
    sortByDate(b.date, a.date),
  );

  // fetch the latest data for the patient
  useEffect(() => {
    // eslint-disable-next-line import/no-deprecated
    dispatch(fetchDeliveries());
    // eslint-disable-next-line import/no-deprecated
    dispatch(fetchPrescriptions());
    // eslint-disable-next-line import/no-deprecated
    dispatch(fetchShipments());
  }, [dispatch]);

  return (
    <DeliveriesOverview
      areShipmentsStale={hasStaleShipments}
      hasPrescriptions={prescriptions.length > 0}
      loading={loading}
      pastShipments={pastShipments}
      upcomingShipments={upcomingShipments}
    />
  );
};
